<template>
  <!-- User add validation -->
  <validator name="meetingValidation">
    <div class="card card-content">
      <div class="card-header">
        <breadcrumb current="Modifier un événement" :label="label"></breadcrumb>
        <h1>Modifier un événement</h1>
        <div class="actions">
          <a class="btn btn-link" href="#" v-link="{path: '/contact/edit/' + contact.id}">Retour</a>
          <a class="btn btn-link" href="#" @click.prevent="update" >Mettre à jour</a>
        </div>
      </div>
      <div class="card-block">
        <meeting-form-edit
          :data.sync          = "data"
          :users              = "users"
          :contact            = "contact"
          :projects           = "projects"
          :presences          = "presences"
          :phases             = "phases"
          :contents           = "contents"
          :trainings          = "trainings"
          :places             = "places"
          :firstintervenants  = "firstintervenants"
          :validation-rules   = "validationRules"
          :authenticated-user = "authenticatedUser"
        ></meeting-form-edit>
      </div>
      <div class="card-footer">
        <div class="actions">
          <a class="btn btn-link" href="#" v-link="{path: '/contact/edit/' + contact.id}">Retour</a>
          <a class="btn btn-link" href="#" @click.prevent="update" >Mettre à jour</a>
        </div>
      </div>
    </div>
  </validator>

</template>

<script>
  // Npm packages
  import moment from 'moment'
  import toastr from 'toastr'

  // jQuery
  import $ from 'jquery'

  // Vuex
  import { meeting, presences, phases, contents, trainings, authenticatedUser, users, firstintervenants, places, contact, projects } from 'src/vuex/getters'
  import { getMeeting, updateMeeting } from 'src/vuex/actions/meetingActions'
  import { getPresences } from 'src/vuex/actions/presenceActions'
  import { getPhases } from 'src/vuex/actions/phaseActions'
  import { getContents } from 'src/vuex/actions/contentActions'
  import { getTrainings } from 'src/vuex/actions/trainingActions'
  import { getPlaces } from 'src/vuex/actions/placeActions'
  import { getFirstintervenants } from 'src/vuex/actions/firstintervenantActions'
  import { getUsers } from 'src/vuex/actions/userActions'
  // import { getContacts } from 'src/vuex/actions/contactActions'
  // import { getProjects } from 'src/vuex/actions/projectActions'

  // getProjectsOfContact
  import store from 'src/vuex/store'
  import { getContact, getProjectsOfContact } from 'src/vuex/actions/contactActions'
  // import { getContact } from 'src/vuex/actions/contactActions'

  // Components
  import MeetingFormEdit from 'src/components/meetings/MeetingFormEdit'
  import Breadcrumb from '../nav/Breadcrumb.vue'

  // Validation
  import { edit as validationRules } from 'src/validations/meetings'

  // Utils
  import { formatMeetingForForm as formatMeeting, formatMeetingForDBInsertion } from 'src/utils/fullcalendar'

  export default {
    vuex: {
      getters: { meeting, presences, phases, contents, trainings, places, firstintervenants, authenticatedUser, users, meetingUpdated: ({ meetings }) => meetings.meetingUpdated, contact, projects },
      actions: { getMeeting, getPresences, getPhases, getContents, getTrainings, getPlaces, updateMeeting, getUsers, getFirstintervenants, getContact }
    },
    data () {
      return {
        data: {
          day: moment().format()
        },
        label: [['', 'Tableau de bord']],
        validationRules
      }
    },
    methods: {
      update () {
        /*
        if (typeof (this.data.title) === 'undefined' || this.data.title === null || this.data.title === '' || this.data.title === 'undefined') {
          this.data.title = 'Sans titre'
        }
        */
        // console.log('meeting substitute ' + this.meeting.userId + '|' + this.meeting.firstintervenant_id + '?' + this.meeting.firstintervenantId + '#' + this.meeting.user + ':' + this.authenticatedUser.id)
        this.meeting.userId = this.meeting.firstintervenantId
        // console.log('updateMeeting |' + this.data.title + '|' + this.data.userId)
        this.updateMeeting(this.meeting, formatMeetingForDBInsertion(this.data))
      }
    },
    watch: {
      'meetingUpdated' (value) {
        if (value) {
          toastr.success('Rdv modifié')
          this.$router.go('/contact/planning/' + this.data.contactId)
        }
      },
      'meetingDeleted' (deleted) {
        if (deleted) {
          this.$router.go('/contact/planning/' + this.data.contactId)
        }
      }
    },
    components: { 'meeting-form-edit': MeetingFormEdit, Breadcrumb },
    ready () {
      let vm = this
      this.getUsers()
      // this.getContacts()
      // this.getProjects()
      this.getPresences()
      this.getPhases()
      this.getContents()
      this.getTrainings()
      this.getPlaces()
      this.getFirstintervenants()
      // vm.getMeetings(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'))
      this.getMeeting(this.$route.params.meetingId)
        .then(() => {
          // console.log('vm.meeting.title' + vm.meeting.title)
          vm.meeting.title = vm.meeting.title.replace(vm.contact.leader_lastname + ' ' + vm.contact.leader_firstname, '')
          vm.meeting.title = vm.meeting.title.replace(vm.contact.leader_firstname + ' ' + vm.contact.leader_lastname, '')
          let phasesTmp = vm.phases.reverse()
          phasesTmp.forEach(function (phase) {
            // console.log('phaseTmp.name ' + phase.name)
            vm.meeting.title = vm.meeting.title.replace(phase.name, '')
          })
          // console.log('contactId ' + vm.contact.id + ' ' + vm.contact.contactId + ' ' + vm.meeting.contact_id)
          if (vm.meeting.contact_id === null) {
            vm.contact.leader_lastname = 'Aucun'
            vm.contact.leader_firstname = ''
            vm.data = formatMeeting(JSON.parse(JSON.stringify(vm.meeting)))
            if (vm.data.title === null) {
              vm.data.title = ''
            }
            // console.log('vm.contact ' + vm.contact.leader_lastname)
            $('.divproject').addClass('hide')
          } else {
            getContact(vm.meeting.contact_id)
            getProjectsOfContact(store, JSON.stringify(vm.meeting.contact_id))
              .then(() => {
                vm.projects.forEach(function (project) {
                  // console.log('project.name ' + project.name)
                  vm.meeting.title = vm.meeting.title.replace(project.name, '')
                })
                vm.data = formatMeeting(JSON.parse(JSON.stringify(vm.meeting)))
                if (vm.data.title === null) {
                  vm.data.title = ''
                }
                // console.log('vm.data.title ' + vm.data.title + ' ' + vm.data.duration + '|' + vm.meeting.duration)
              })
          }
        })
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// MeetingEdit.vue?4798e023